<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-26 11:09:08
-->
<template>
  <div id="box" class="box">
    <div id="right" class="right">
      <div class="right-flex">
        <div>
             <el-button
          @click="exportData"
          v-if="codeData.indexOf('405') != -1"
          type="primary"
           style="margin-right: 12px;"
          >导出数据</el-button
        >
        <a-dropdown>
          <a-button
            v-show="codeData.indexOf('400') != -1"
            class="btn-p"
            @click="contSeting"
          >
            统计配置
          </a-button>
        </a-dropdown>
        </div>
        <div class="search">
          <a-range-picker  style="margin-right:8px;max-width:350px" showTime v-model="timeTwo" format="YYYY-MM-DD HH:mm:ss"/>
          <el-select
            clearable
            style="margin-left: 10px"
            v-model="tableOne"
            @change="change"
            placeholder="按统计表选择"
          >
           
            <el-option :key="index" v-for="(item,index) in tableList " :label="item.name" :value="item.id"> </el-option>
            
        </el-select>
            <el-button class="search-box" type="primary"  @click="listSearch">查询</el-button>
        </div>
      </div>
      <coententTable
        :y="height"
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :dataSource="dataSource"
        :customSlot="customSlot"
        @handleSizeChange="handleSizeChange"
        :loading="loading"
      >
      </coententTable>
      <div id="pagination" class="pagination">
        <a-pagination
          :current="pagination.current"
          :pageSize="pagination.pageSize"
          show-size-changer
          show-quick-jumper
          :total="pagination.total"
          @change="onShowSizeChange"
          @showSizeChange="handleSizeChange"
          :page-size-options="pagination.pageSizeOptions"
          :show-total="(total) => `共 ${pagination.total} 条`"
        />
      </div>
    </div>
    <StatisticalConfig @closeTwo="closeTwo" :visible="visible"> </StatisticalConfig>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import StatisticalConfig from './statistical_configuration.vue';
import {
  selectList,
  scoringStatisticsCount,
  exportData,
} from "./index";
export default {
  data() {
    return {
      value: "",
      tableOne:'',
      height: 0,
      timeTwo: [],
      selectValue: 0,
      tableList:[],
      columns: [],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
        {
          name: "sort",
          customRender: "sort",
        },
        {
          name: "titleTwo",
          customRender: "titleTwo",
        },
      ],
      loading: false,
      time: "",
      sortValue: "0",
      codeData: [],
      dialogVisibleTwo: false,
      deleteItem: {},
      deleteShow: false,
      visible:false,
    };
  },
  components: {
    coententTable,
    StatisticalConfig,
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.getTableList();
  },
  methods: {
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    exportData(){
        let startTime = "";
        let endTime = "";
        if (this.timeTwo.length > 0) {
          startTime = this.farmatDate(
            new Date(this.timeTwo[0].toString()).getTime(),
            "-"
          );
          endTime = this.farmatDate(
            new Date(this.timeTwo[1].toString()).getTime(),
            "-"
          );
        }
        exportData({
          id:this.tableOne,
          startTime,
          endTime,
          current: this.pagination.current,
          size: this.pagination.pageSize,
          fileName:'报送统计',
        }).then((res)=>{

        })
    },
    getTableList(){
      selectList({

      }).then((res)=>{
          if(res.code == 0){
              this.tableList = res.data;
              this.tableOne = res.data[0].id;
              this.getList();
          }
      })
    },
    change(e){
        this.tableOne = e;
    },
    contSeting(){
        this.visible = true;
    },
    onShowSizeChange(current) {
      console.log();
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getList() {
      this.loading = true;
      this.columns = [];
      let startTime = "";
      let endTime = "";
      if (this.timeTwo.length > 0) {
        startTime = this.farmatDate(
          new Date(this.timeTwo[0].toString()).getTime(),
          "-"
        );
        endTime = this.farmatDate(
          new Date(this.timeTwo[1].toString()).getTime(),
          "-"
        );
      }
      scoringStatisticsCount({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        startTime,
        endTime,
        id:this.tableOne,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = JSON.parse(JSON.stringify(res.data.body.records));
          this.pagination.current = res.data.body.current;
          this.pagination.total = res.data.body.total;
          this.height = 0;
          let header = res.data.header[0];
          for (const key in header) {
              this.columns.push( {
                title: header[key],
                dataIndex: key,
                ellipsis: true,
                width: 200,
                fixed:key=='name'?'left':key=='countNumber'?'right':''
              },)
          }
          if (this.pagination.total > 0) {
            this.height = document.documentElement.clientHeight - 480;
            window.onresize = () => {
              return (() => {
                this.height = document.documentElement.clientHeight - 480;
              })();
            };
          }
          this.loading = false;
        }
      });
    },
    closeTwo(){
      this.visible = false;
    }
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  height: 100%;
  width: 100%;
  //position: relative;
  .left {
    width: 250px;
    font-size: 14px;
    border-right: solid 1px #f2f3f5;
    color: #000;
    padding: 24px;
    padding-top: 0px;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    .ant-tree {
      min-height: 300px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
    /deep/ .ant-btn-primary {
      color: #fff !important;
      background-color: #1890ff !important;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    width: 100%;
    font-size: 14px;
    color: #000;
    width: 500px;
    .right-name {
      padding-left: 24px;
    }
    .search {
      display: flex;
      margin-left: 24px;
      margin-right: 24px;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
    }
  }
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.right-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 24px;
  margin-bottom: 20px;
  .search {
    margin-left: 6px !important;
  }
  /deep/ .ant-btn,
  .ant-dropdown-trigger {
    height: 40px;
    background: #ecf5ff;
    color: #18abff;
    border-color: #c9e3ff;
    text-align: center;
  }
  /deep/ .ant-dropdown-menu-item {
    text-align: center;
  }
  /deep/ .ant-dropdown-trigger {
    border-radius: 3px;
    background-color: rgba(240, 246, 255, 1) !important;
    text-align: center;
    border: 1px solid rgba(23, 109, 230, 1) !important;
    color: rgba(23, 109, 230, 1) !important;
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
  width: 300px;
}

.table-th {
  width: 126px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table-tn {
  width: 60px;
  height: 24px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Microsoft Yahei;
  text-align: center;
  line-height: 24px;
}
.table_one {
  border: solid 1px #ccc;
  width: 100%;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 101px;
  border-radius: 5px;
}
.sort-box {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-box-two {
  width: 28px;
  height: 28px;
  background: #f5f7fa;
  text-align: center;
  line-height: 28px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .ant-btn {
    border: none;
    width: 100%;
    height: 100%;
    background: none;
  }
}
.sort-two {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.sort-style {
  width: 43px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  flex: 1;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 1px;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-right: 24px;
  bottom: 0px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.zhi-ding {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(237, 109, 103, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(237, 109, 103, 0.3);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
.tui-song {
  width: 40px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(24, 109, 230, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(24, 109, 230, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.icon-box-img {
  cursor: pointer;
}
#resize {
  width: 5px;
  height: 100%;
  cursor: w-resize;
  float: left;
}
.right-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  .right-title-box-txt {
    color: rgba(102, 111, 128, 1);
    font-size: 14px;
    text-align: right;
    font-family: Roboto-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    height: 406px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
    padding-bottom: 20px;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 13px;
  }
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-bold;
    font-weight: 600;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
}
.choose-column-box {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .table {
  margin-top: 0px;
}
.search-box {
   margin-left: 12px;
}
/deep/ .ant-tree.ant-tree-show-line li:not(:last-child)::before {
  border-left: 1px dashed rgba(187, 187, 187, 1);
}
.title-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: underline;
  color: rgba(24, 109, 230, 1);
}
.tips-box {
  /deep/ .el-dialog__title {
    color: rgba(48, 49, 51, 1);
    font-size: 18px;
    font-family: Roboto-black;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>